import { Variation } from '../order/types';

/**
 * Action types
 * @LOAD_VARIATIONS: update actual variations list
 * @HANDLE_VARIATIONS_ITEMS : insert product in order items
 * @CLEAR_VARIATIONS_ITEMS : clear variations items
 */
export enum VariationsTypes {
  LOAD_VARIATIONS = '@variations/LOAD_VARIATIONS',
  HANDLE_VARIATIONS_ITEMS = '@variations/HANDLE_VARIATIONS_ITEMS',
  CLEAR_VARIATIONS_ITEMS = '@variations/CLEAR_VARIATIONS_ITEMS',
}
/**
 * State type
 * @data
 */
export interface VariationsState {
  variations: Variation[]
}
